module.exports = __webpack_public_path__ + "img/csoki.e1be92f7.png";